<div class="main-container" data-cy="forms-summary-container">

  <div class="header" data-cy="forms-summary-header">Form Summary</div>
  <div class="close-button" data-cy="forms-summary-close-button-container">
    <button mat-button (click)="close()" data-cy="forms-summary-close-button"><i class="material-icons">close</i></button>
  </div>

  <div *ngFor="let item of summaryItems; let i = index;" class="form-item" data-cy="forms-summary-item-{{i}}">
    <app-forms-item 
                    class="inline item"
                    [actionsEnabled]="false"
                    [itemIndex]="i"
                    [CaseWorkItemFormsId]="CaseWorkItemFormsId"
                    [paragraphOrder]="0"
                    [dataFormID]="dataFormID"
                    [sideBySide]="true"
                    [saveEmitter]="saveEmitter"
                    [dataFormItem]="item"
                    data-cy="forms-summary-forms-item-{{i}}"></app-forms-item>
  </div>

  <div class="action-container" data-cy="forms-summary-action-container">
    <button mat-raised-button color="primary" (click)="close()" data-cy="forms-summary-done-button">Done</button>
  </div>

</div>
